document.addEventListener("DOMContentLoaded", function () {

  const cards = document.querySelectorAll(".custom-color-card");

  cards.forEach(function(card){

    card.addEventListener("click", function(){

      cards.forEach(function(item){
        item.classList.remove("active");
      });

      this.classList.add("active");

      const variantId = this.dataset.variantId;

      const hiddenInput = document.querySelector(
        'form[action="/cart/add"] input[name="id"]'
      );

      if(hiddenInput){
        hiddenInput.value = variantId;
        hiddenInput.dispatchEvent(
          new Event("change",{bubbles:true})
        );
      }

      const radio = document.querySelector(
        '.product-form__input--swatch input[data-option-value-id]'
      );

      if(radio){
        radio.closest("variant-selects").dispatchEvent(
          new Event("change",{bubbles:true})
        );
      }

      window.location.href =
        window.location.pathname + "?variant=" + variantId;

    });

  });

});